
import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';

// Blog Data with EXACT content from Vlinkin Professionals website
const blogPosts = [
  {
    id: 1,
    title: "About Vlinkin Professional LLP",
    excerpt: "At Vlinkin Professional LLP, we're dedicated to shaping the next generation of software development professionals.",
    content: `At Vlinkin Professional LLP, we're dedicated to shaping the next generation of software development professionals. Our mission is to provide exceptional education and career support, enabling aspiring developers to achieve their dreams.

With a focus on real-time projects, guaranteed placements, and comprehensive soft skills training, we prepare our trainees to shine in the competitive tech landscape.

Join us, and let's build a brighter future together.`,
    author: "Admin",
    image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800",
    category: "About Us"
  },
  {
    id: 2,
    title: "Why Vlinkin Professional LLP Stands Out",
    excerpt: "Learn from industry veterans, innovative curriculum, tailored learning experience, and thriving community.",
    content: `**Expert Mentorship**

Learn from industry veterans who bring years of expertise and insights. Our trainers are more than instructors; they are mentors dedicated to your success.

**Innovative Curriculum**

Stay ahead of the curve with our cutting-edge curriculum that covers AI, data science, blockchain, and cybersecurity. We ensure you're equipped with the latest and most relevant skills.

**Tailored Learning Experience**

We recognize that every learner is unique. Our programs are flexible and adaptive, offering personalized learning journeys that cater to your individual strengths and aspirations.

**Thriving Community**

Join a vibrant community of like-minded learners and professionals. At Vlinkin Professional LLP, you'll find a supportive network where knowledge sharing and collaboration thrive.`,
    author: "Admin",
    image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=800",
    category: "Why Vlinkin"
  },
  {
    id: 3,
    title: "Your Journey Starts Here at Vlinkin",
    excerpt: "Begin your path to becoming a software development professional with our comprehensive programs.",
    content: `Your journey to becoming a successful software development professional starts here at Vlinkin Professional LLP.

We offer comprehensive programs designed to take you from beginner to job-ready professional. Our approach combines technical training, real-world projects, and career support to ensure your success.

Whether you are just starting out or looking to advance your career, Vlinkin provides the guidance, resources, and community you need to achieve your goals.

Take the first step today. Your future in tech awaits.`,
    author: "Admin",
    image: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=800",
    category: "Get Started"
  },
  {
    id: 4,
    title: "Master the Art of Soft Skills: Become the Complete Professional",
    excerpt: "Master the art of Soft Skills: Become the complete professional",
    content: `While technical prowess is crucial, it's the soft skills that often set great professionals apart. 

Our training program goes beyond coding and development. We cultivate effective communication, teamwork, and critical thinking skills, ensuring you're not just a good developer, but a great professional. 

These skills are the secret sauce to career growth and are highly coveted by employers.`,
    author: "Admin",
    image: "https://images.unsplash.com/photo-1552581234-26160f608093?w=800",
    category: "Soft Skills"
  },
  {
    id: 5,
    title: "Secure Your Future: Confirmed Job Placements",
    excerpt: "Secure Your Future: Confirmed Job Placements",
    content: `Worried about job security after training? Worry no more. 

At Vlinkin Professional LLP, we guarantee job placements for our trainees. Our robust network of industry partners and our stellar reputation for producing proficient professionals open doors to a plethora of job opportunities. 

Step into the professional realm assured of a promising future.`,
    author: "Admin",
    image: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=800",
    category: "Placements"
  },
  {
    id: 6,
    title: "Dive into Real-Time Projects: Learn by Doing",
    excerpt: "Dive into Real-Time Projects: Learn by Doing",
    content: `Imagine this: you're not just learning theories, but actively applying them to solve real-world challenges. 

That's the Vlinkin Professional LLP difference. Our trainees engage in hands-on projects that mirror the complexities of the tech industry, gaining invaluable experience that textbooks alone can't offer. 

This approach not only hones your technical abilities but also instills the confidence needed to innovate and excel.`,
    author: "Admin",
    image: "https://images.unsplash.com/photo-1504384764586-bb4cdc1707b0?w=800",
    category: "Projects"
  },
  {
    id: 7,
    title: "Propel Your Career to New Heights with Vlinkin Professional LLP",
    excerpt: "Propel your career to new heights with Vlinkin Professional LLP",
    content: `In today's dynamic digital world, the demand for top-tier software developers is skyrocketing. 

At Vlinkin Professional LLP, we're not just keeping pace; we're setting the standard. Our 6-month placement training programs are meticulously designed to transform budding talent into industry-ready professionals. 

Through immersive real-time projects, guaranteed job placements, and holistic soft skills training, we provide the perfect launchpad for your tech career.`,
    author: "Admin",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800",
    category: "Career"
  },
  {
    id: 8,
    title: "Machine Learning: A Crash Course for Curious Minds",
    excerpt: "Machine Learning: A crash course for curious minds",
    content: `Machine learning (ML) is a transformative technology rapidly changing the landscape of every industry, from healthcare and finance to entertainment and transportation. But what exactly is it? And how does it work?

In this blog, we offer a concise overview of its core concepts, popular applications, and potential future directions.

**What is Machine Learning?**

Imagine a computer program that can learn and improve on its own, without being explicitly programmed. That's the essence of machine learning. Instead of following rigid instructions, ML algorithms can analyze data, identify patterns, and make predictions or decisions based on their findings.

Think of it like training a puppy. You don't give it detailed instructions on how to fetch a ball. Instead, you show it what fetch looks like, reward its successes, and correct its mistakes. Over time, the puppy learns through experience.

**Types of Machine Learning**

- Supervised Learning: The algorithm is trained on labeled data, learning to map input to desired output.

- Unsupervised Learning: The data is unlabeled, and the algorithm discovers patterns on its own.

- Reinforcement Learning: The algorithm learns through trial and error, receiving rewards for desirable actions.

**Applications of Machine Learning**

- Recommender systems for products and movies
- Fraud detection in financial transactions
- Medical diagnosis and treatment planning
- Self-driving cars and autonomous navigation

**Conclusion**

Machine learning is a powerful tool with the potential to revolutionize various aspects of our lives. Understanding its core concepts can empower us to make informed decisions about this evolving technology.`,
    author: "Admin",
    image: "https://images.unsplash.com/photo-1509228627152-72ae9ae6848d?w=800",
    category: "Technology"
  }
];

// Inject hover CSS once
const styleSheet = document.createElement("style");
styleSheet.textContent = `
  .blog-card-hover:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 24px rgba(0,0,0,0.12) !important;
  }
  .load-more-btn:hover {
    background: #0a2540 !important;
    color: white !important;
    transform: translateY(-2px);
  }
  .back-button:hover {
    color: #0a2540 !important;
  }
  .nav-link-btn:hover {
    color: #ffb347 !important;
  }
`;
if (!document.head.querySelector('[data-blog-styles]')) {
  styleSheet.setAttribute('data-blog-styles', 'true');
  document.head.appendChild(styleSheet);
}

const BlogPage = () => {
  const [visiblePosts, setVisiblePosts] = useState(6);
  const [selectedPost, setSelectedPost] = useState(null);

  // Scroll to top when post changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [selectedPost]);

  const displayedPosts = blogPosts.slice(0, visiblePosts);
  const hasMorePosts = visiblePosts < blogPosts.length;

  const loadMore = () => {
    setVisiblePosts(prev => prev + 3);
  };

  const getImageUrl = (image) => {
    return image || 'https://via.placeholder.com/800x600/0a2540/ffffff?text=Vlinkin+Blog';
  };

  const getAuthorInitial = (author) => {
    return (author || 'Vlinkin Team').charAt(0).toUpperCase();
  };

  // ─── DETAIL VIEW ───────────────────────────────────────────────────────────
  if (selectedPost) {
    return (
      <div style={styles.detailPage}>
        <Navigation />

        <div style={styles.container}>
          {/* Back Button */}
          <div style={styles.detailNav}>
            <button
              className="back-button"
              onClick={() => setSelectedPost(null)}
              style={styles.backButton}
            >
              <span style={styles.arrow}>←</span> Back to all articles
            </button>
          </div>

          {/* Article */}
          <article style={styles.classicArticle}>
            <header style={styles.articleHeader}>
              <div style={styles.categoryTag}>
                {selectedPost.category || 'Article'}
              </div>
              <h1 style={styles.articleTitle}>{selectedPost.title}</h1>

              {/* Author Info */}
              <div style={styles.byline}>
                <div style={styles.authorInfo}>
                  <div style={styles.authorAvatar}>
                    {getAuthorInitial(selectedPost.author)}
                  </div>
                  <div style={styles.authorDetails}>
                    <span style={styles.authorName}>By {selectedPost.author || 'Vlinkin Team'}</span>
                    <span style={styles.authorTitle}>Vlinkin Professionals</span>
                  </div>
                </div>
              </div>
            </header>

            {/* Featured Image */}
            {selectedPost.image && (
              <div style={styles.featuredImage}>
                <img
                  src={getImageUrl(selectedPost.image)}
                  alt={selectedPost.title}
                  style={styles.featuredImageImg}
                />
              </div>
            )}

            {/* Article Content */}
            <div style={styles.articleContent}>
              <ReactMarkdown
                components={{
                  h1: ({ node, ...props }) => <h1 style={styles.contentH1} {...props} />,
                  h2: ({ node, ...props }) => <h2 style={styles.contentH2} {...props} />,
                  h3: ({ node, ...props }) => <h3 style={styles.contentH3} {...props} />,
                  p:  ({ node, ...props }) => <p  style={styles.contentP}  {...props} />,
                  blockquote: ({ node, ...props }) => <blockquote style={styles.contentBlockquote} {...props} />,
                  strong: ({ node, ...props }) => <strong style={styles.contentStrong} {...props} />,
                }}
              >
                {selectedPost.content}
              </ReactMarkdown>
            </div>

            {/* Footer */}
            <footer style={styles.articleFooter}>
              <div style={styles.postNavigation}>
                <button
                  className="nav-link-btn"
                  onClick={() => setSelectedPost(null)}
                  style={styles.navLink}
                >
                  ← View all articles
                </button>
              </div>
            </footer>
          </article>
        </div>
      </div>
    );
  }

  // ─── LIST VIEW ─────────────────────────────────────────────────────────────
  return (
    <div style={styles.listPage}>
      <Navigation />

      {/* Hero Section */}
      <div style={styles.heroSection}>
        <div style={styles.container}>
          <h1 style={styles.heroTitle}>
            Vlinkin Professionals <span style={styles.heroSpan}>Blog</span>
          </h1>
          <p style={styles.heroSubtitle}>Empowering Minds, Transforming Futures</p>
        </div>
      </div>

      {/* Blog Grid */}
      <div style={styles.gridSection}>
        <div style={styles.container}>
          {displayedPosts.length === 0 ? (
            <div style={styles.noPosts}>
              <p>No blog posts available yet. Check back soon!</p>
            </div>
          ) : (
            <>
              <div style={styles.blogGrid}>
                {displayedPosts.map(post => (
                  <article
                    key={post.id}
                    className="blog-card-hover"
                    style={styles.blogCard}
                    onClick={() => setSelectedPost(post)}
                  >
                    <div style={styles.postImage}>
                      <img
                        src={getImageUrl(post.image)}
                        alt={post.title}
                        style={styles.postImageImg}
                        onError={(e) => {
                          e.target.src = 'https://via.placeholder.com/800x600/0a2540/ffffff?text=Vlinkin+Professionals';
                        }}
                      />
                    </div>
                    <div style={styles.postContent}>
                      <h3 style={styles.postTitle}>{post.title}</h3>
                      <p style={styles.postExcerpt}>{post.excerpt}</p>
                      <div style={styles.readMoreBtn}>Read More →</div>
                    </div>
                  </article>
                ))}
              </div>

              {/* Load More Button */}
              {hasMorePosts && (
                <div style={styles.loadMoreContainer}>
                  <button
                    className="load-more-btn"
                    onClick={loadMore}
                    style={styles.loadMoreBtn}
                  >
                    Load More Articles ({blogPosts.length - visiblePosts} remaining)
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

// ─── STYLES ──────────────────────────────────────────────────────────────────
const styles = {
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px',
  },

  // ── List Page ──
  listPage: {
    background: '#f8f9fa',
    minHeight: '100vh',
  },

  heroSection: {
    background: 'linear-gradient(135deg, #0a2540 0%, #1a4a6f 100%)',
    padding: '100px 0 80px 0',   // extra top padding to clear fixed navbar
    textAlign: 'center',
    marginBottom: '60px',
  },

  heroTitle: {
    fontSize: '3.5rem',
    color: 'white',
    fontWeight: '700',
    margin: 0,
    padding: 0,
  },

  heroSpan: {
    color: '#ffb347',
  },

  heroSubtitle: {
    fontSize: '1.2rem',
    color: 'rgba(255,255,255,0.9)',
    maxWidth: '600px',
    margin: '15px auto 0 auto',
  },

  gridSection: {
    padding: '0 0 80px 0',
  },

  blogGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
    gap: '30px',
    marginBottom: '50px',
  },

  blogCard: {
    background: 'white',
    borderRadius: '12px',
    overflow: 'hidden',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },

  postImage: {
    width: '100%',
    height: '240px',
    overflow: 'hidden',
  },

  postImageImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'transform 0.3s ease',
  },

  postContent: {
    padding: '25px',
  },

  postTitle: {
    fontSize: '1.35rem',
    marginBottom: '12px',
    color: '#0a2540',
    lineHeight: '1.4',
    fontWeight: '600',
  },

  postExcerpt: {
    color: '#6c757d',
    lineHeight: '1.6',
    marginBottom: '20px',
    fontSize: '0.95rem',
  },

  readMoreBtn: {
    color: '#ffb347',
    fontWeight: '600',
    fontSize: '0.9rem',
  },

  loadMoreContainer: {
    textAlign: 'center',
    marginTop: '40px',
  },

  loadMoreBtn: {
    background: 'transparent',
    border: '2px solid #0a2540',
    color: '#0a2540',
    padding: '12px 30px',
    fontSize: '1rem',
    fontWeight: '600',
    borderRadius: '40px',
    cursor: 'pointer',
    transition: 'all 0.3s',
  },

  noPosts: {
    textAlign: 'center',
    padding: '60px 20px',
    background: 'white',
    borderRadius: '12px',
    color: '#666',
  },

  // ── Detail Page ──
  detailPage: {
    background: '#f5f5f0',
    minHeight: '100vh',
    paddingBottom: '80px',
  },

  detailNav: {
    marginBottom: '30px',
    paddingTop: '100px',   // clears fixed navbar height
  },

  backButton: {
    background: 'none',
    border: 'none',
    color: '#666',
    fontSize: '0.95rem',
    cursor: 'pointer',
    padding: '8px 0',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    fontFamily: 'Georgia, serif',
    transition: 'color 0.2s',
  },

  arrow: {
    fontSize: '1.2rem',
  },

  classicArticle: {
    maxWidth: '850px',
    margin: '0 auto',
    background: 'white',
    borderRadius: '4px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
  },

  articleHeader: {
    padding: '50px 60px 30px 60px',
    borderBottom: '1px solid #e8e8e8',
  },

  categoryTag: {
    display: 'inline-block',
    fontSize: '0.7rem',
    textTransform: 'uppercase',
    letterSpacing: '2px',
    fontWeight: '600',
    color: '#ffb347',
    marginBottom: '20px',
    fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, sans-serif',
  },

  articleTitle: {
    fontSize: '2.8rem',
    lineHeight: '1.2',
    color: '#1a1a1a',
    marginBottom: '25px',
    fontWeight: '400',
    letterSpacing: '-0.01em',
    fontFamily: 'Georgia, Times New Roman, Times, serif',
  },

  byline: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '20px',
    paddingTop: '15px',
    borderTop: '1px solid #f0f0f0',
  },

  authorInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },

  authorAvatar: {
    width: '40px',
    height: '40px',
    background: 'linear-gradient(135deg, #0a2540, #1a4a6f)',
    color: 'white',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '600',
    fontSize: '1.1rem',
    fontFamily: 'serif',
  },

  authorDetails: {
    display: 'flex',
    flexDirection: 'column',
  },

  authorName: {
    fontWeight: '600',
    color: '#1a1a1a',
    fontSize: '0.9rem',
    fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, sans-serif',
  },

  authorTitle: {
    fontSize: '0.75rem',
    color: '#999',
    marginTop: '2px',
  },

  featuredImage: {
    margin: '0 60px',
    borderRadius: '4px',
    overflow: 'hidden',
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
  },

  featuredImageImg: {
    width: '100%',
    height: 'auto',
    display: 'block',
  },

  articleContent: {
    padding: '50px 60px',
    fontFamily: 'Georgia, Times New Roman, Times, serif',
    fontSize: '1.1rem',
    lineHeight: '1.8',
    color: '#1a1a1a',
    maxWidth: '750px',
    margin: '0 auto',
  },

  contentH1: {
    fontSize: '2rem',
    margin: '1.2em 0 0.6em 0',
    fontWeight: '500',
    color: '#1a1a1a',
    fontFamily: 'Georgia, serif',
    lineHeight: '1.3',
  },

  contentH2: {
    fontSize: '1.5rem',
    margin: '1.2em 0 0.5em 0',
    fontWeight: '500',
    color: '#2c3e50',
    fontFamily: 'Georgia, serif',
  },

  contentH3: {
    fontSize: '1.25rem',
    margin: '1em 0 0.4em 0',
    fontWeight: '600',
    color: '#34495e',
    fontFamily: 'Georgia, serif',
  },

  contentP: {
    marginBottom: '1.4em',
    lineHeight: '1.8',
    color: '#2c3e50',
    textAlign: 'left',
  },

  contentBlockquote: {
    margin: '1.8rem 0',
    padding: '0.8rem 0 0.8rem 2rem',
    borderLeft: '3px solid #cbd5e0',
    fontStyle: 'italic',
    color: '#4a5568',
    fontFamily: 'Georgia, serif',
    background: 'transparent',
  },

  contentStrong: {
    fontWeight: '700',
    color: '#1a1a1a',
  },

  articleFooter: {
    padding: '30px 60px 50px 60px',
    borderTop: '1px solid #e8e8e8',
    background: '#fafaf8',
  },

  postNavigation: {
    textAlign: 'center',
  },

  navLink: {
    background: 'none',
    border: 'none',
    color: '#0a2540',
    fontSize: '0.9rem',
    cursor: 'pointer',
    fontWeight: '500',
    transition: 'color 0.2s',
    fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, sans-serif',
  },
};

export default BlogPage;